/* The "new" values for the Validation tab: { validation_figure: [ ...rows ], validation_report: [ ...rows ] }.
 *   validation_figure  settlement_report_figure_latest: one row per report, month and line item
 *   validation_report  settlement_report_latest: one row per report (the header values); optional - without it the header is not compared
 * (What was reported comes from settlement_report and settlement_report_figure, through the reports API.) The app only reads this. Where it comes from (first that works):
 *   1. the server's /__srs_validation: the settlement_report_figure_latest table in PostgreSQL (or, with VALIDATION_STORE=json / in development, a JSON file)
 *   2. the sample bundled with the app (src/demo/db/srs-validation.seed.json)
 */
import seed from '../demo/db/srs-validation.seed.json';

const ENDPOINT = '/__srs_validation';
const valid = (doc) => !!doc && Array.isArray(doc.validation_figure);
let kind = 'sample';
let latestTable = 'settlement_report_figure_latest';
let latestReportTable = 'settlement_report_latest';

/** -> { figures, reports }  (reports is null when the source has no header table) */
export async function loadValidation() {
  try {
    const res = await fetch(ENDPOINT);
    if (res && res.ok) {
      const type = (res.headers && res.headers.get && res.headers.get('content-type')) || '';
      if (type.includes('json')) {                         // a static host answers unknown paths with index.html
        const doc = await res.json();
        if (valid(doc)) { kind = doc.source === 'database' ? 'database' : 'file'; return { figures: doc.validation_figure, reports: Array.isArray(doc.validation_report) ? doc.validation_report : null }; }
      }
    }
  } catch { /* no server: use the sample */ }
  kind = 'sample';
  return { figures: seed.validation_figure, reports: Array.isArray(seed.validation_report) ? seed.validation_report : null };
}
export const validationLabel = () => (kind === 'database' ? `the ${latestReportTable} and ${latestTable} tables` : kind === 'file' ? 'a JSON file on the server' : 'the sample data bundled with the app');
